import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import { Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
// hooks
import {useResponsive} from '../hooks/use-responsive';
import {useAuthContext} from '../auth/hooks';
// components
import Logo from '../components/logo';
import Scrollbar from '../components/scrollbar';
import {usePathname} from '../routes/hooks';
import {NavSectionVertical} from '../components/nav-section';
//
import {NAV} from './config-layout';
import {useNavData} from './config-navigation';
import {NavToggleButton} from './_common';
import Iconify from '../components/iconify';
import PowerBy from '../components/power-by/power-by';

// ----------------------------------------------------------------------

export default function NavVertical({openNav, onCloseNav, files, valid}) {
    const { logout } = useAuthContext();

    const pathname = usePathname();

    const lgUp = useResponsive('up', 'lg');

    const navData = useNavData(files, valid);

    const handleLogout = () => {
        logout();
    };

    useEffect(() => {
        if (openNav) {
            onCloseNav();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                '& .simplebar-content': {
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Logo sx={{mt: 3, ml: 4, mb: 1, p: 2}}/>
            <NavSectionVertical
                data={navData}
                // config={{
                //     currentRole: user?.role || 'admin',
                // }}
            />

            <Box sx={{flexGrow: 1}}/>
            <List sx={{ px: 2, pb: 3 }}>
                <ListItemButton onClick={handleLogout} sx={{ color: 'text.secondary' }}>
                    <ListItemIcon>
                        <Iconify icon="ic:outline-logout" width={24} />
                    </ListItemIcon>
                    <ListItemText primary="Cerrar sesión" />
                </ListItemButton>
                <Divider sx={{ my: 1 }} />
                <PowerBy />
            </List>
            {/* <NavUpgrade/> */}
        </Scrollbar>
    );

    if (lgUp) {
        return (
            <Box
            component="nav"
            sx={{
                flexShrink: {lg: 0},
                width: {lg: NAV.W_VERTICAL},
            }}
            >
            <NavToggleButton/>
                <Stack
                    sx={{
                        height: 1,
                        position: 'fixed',
                        width: NAV.W_VERTICAL,
                        borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
                    }}
                >
                    {renderContent}
                </Stack>
            </Box>
        );
    }

    return (
        <Drawer
            open={openNav}
            onClose={onCloseNav}
            PaperProps={{
                sx: {
                    width: NAV.W_VERTICAL,
                },
            }}
        >
            {renderContent}
        </Drawer>
    );

    // return (
    //     <Box
    //         component="nav"
    //         sx={{
    //             flexShrink: {lg: 0},
    //             width: {lg: NAV.W_VERTICAL},
    //         }}
    //     >
    //         <NavToggleButton/>

    //         {lgUp ? (
    //             <Stack
    //                 sx={{
    //                     height: 1,
    //                     position: 'fixed',
    //                     width: NAV.W_VERTICAL,
    //                     borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
    //                 }}
    //             >
    //                 {renderContent}
    //             </Stack>
    //         ) : (
    //             <Drawer
    //                 open={openNav}
    //                 onClose={onCloseNav}
    //                 PaperProps={{
    //                     sx: {
    //                         width: NAV.W_VERTICAL,
    //                     },
    //                 }}
    //             >
    //                 {renderContent}
    //             </Drawer>
    //         )}
    //     </Box>
    // );
}

NavVertical.propTypes = {
    onCloseNav: PropTypes.func,
    openNav: PropTypes.bool,
    files: PropTypes.bool,
    valid: PropTypes.bool,
};
